import React from "react";
import "./online.css";

export default function Online() {

    return (
    <div class="ring-container">
        <div class="ringring"></div>
        <div class="circle"></div>
    </div>
    );
}